// Role Display Names Mapping
// Internal values stay the same (owner, co-owner, staff)
// Only the displayed text changes

export const ROLE_DISPLAY_NAMES = {
  'owner': 'Director',
  'co-owner': 'Supervisor/Administrator',
  'business-manager': 'Business Manager',
  'staff': 'Staff',
  'parent': 'Parent'
};

export const getRoleDisplayName = (role) => {
  return ROLE_DISPLAY_NAMES[role?.toLowerCase()] || role || 'Staff';
};

export const ROLE_OPTIONS = [
  { value: 'owner', label: 'Director' },
  { value: 'co-owner', label: 'Supervisor/Administrator' },
  { value: 'business-manager', label: 'Business Manager' },
  { value: 'staff', label: 'Staff' },
  { value: 'parent', label: 'Parent' }
];
